import React from 'react';

interface ErrorBoundaryState {
    hasError: boolean;
}

// Outermost safety net: a render error anywhere below would otherwise unmount the
// whole app to a blank screen. The fallback intentionally uses no providers
// (plain markup) so it still renders even if a provider itself is what failed.
export class ErrorBoundary extends React.Component<
    { children: React.ReactNode },
    ErrorBoundaryState
> {
    state: ErrorBoundaryState = { hasError: false };

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        // eslint-disable-next-line no-console
        console.error('Unhandled UI error:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
                    <h2>Algo salió mal.</h2>
                    <p>
                        Recarga la página. Si el problema persiste, contacta a
                        soporte.
                    </p>
                    <button onClick={() => window.location.reload()}>
                        Recargar
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
